import React from 'react'
import Button from '../../../Components/Button'
import PhoneButton from '../../../Components/PhoneButton'

export default function BasketSummary({ total, count, onNext, nextLabel, allowSkip = false, phoneNumber }) {

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 shadow-lg" role="region" aria-label="Basket actions">
      <Button
        onClick={onNext}
        disabled={count === 0 && !allowSkip}
        variant="primary"
        theme="dark"
        size="sm"
        fullWidth
      >
        {count > 0 || allowSkip ? nextLabel : 'Add items to continue'}
      </Button>

      <PhoneButton
        phoneNumber={phoneNumber}
        size="sm"
        className="mt-2 !bg-transparent !text-gray-600 hover:!text-gray-800 border-0"
        ariaLabel="Phone in an order"
      >
        Phone in an order
      </PhoneButton>
    </div>
  )
}
